import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const DELETE_DOMAIN: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation deleteDomain($input: DeleteDomainInput!) {
    deleteDomain(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
